<template>
  <div class="vdn__container">
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/1_zh.png" alt="">
      <img v-else src="@/assets/images/1/1.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/2_zh.png" alt="">
      <img v-else src="@/assets/images/1/2.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/3_zh.png" alt="">
      <img v-else src="@/assets/images/1/3.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/4_zh.png" alt="">
      <img v-else src="@/assets/images/1/4.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/5_zh.png" alt="">
      <img v-else src="@/assets/images/1/5.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/6_zh.png" alt="">
      <img v-else src="@/assets/images/1/6.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/7_zh.png" alt="">
      <img v-else src="@/assets/images/1/7.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/8_zh.png" alt="">
      <img v-else src="@/assets/images/1/8.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/9_zh.png" alt="">
      <img v-else src="@/assets/images/1/9.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/10_zh.png" alt="">
      <img v-else src="@/assets/images/1/10.png" alt="">
    </div>
    <div class="mmf__item">
      <span class="mmf__item_padding"></span>
      <img src="@/assets/images/1/15.jpg" alt="">
    </div>
    <div class="mmf__item">
      <span class="mmf__item_padding"></span>

      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/14_zh.jpg" alt="">
      <img v-else src="@/assets/images/1/14.jpg" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/12_zh.png" alt="">
      <img v-else src="@/assets/images/1/12.png" alt="">
    </div>
    <div class="mmf__item">
      <img v-if="lan === 'zh_CN'" src="@/assets/images/1/11_zh.png" alt="">
      <img v-else src="@/assets/images/1/11.png" alt="">
    </div>

  </div>
</template>
<script>
export default {
  name: 'mmfLoading',
  computed: {
    lan() {
      return this.$store.state.baseData.lan;
    },
  },
  methods: {
    // goIo() {
    //   window.location.href = 'https://www.vdollar.io/';
    // },
  },
};
</script>
<style>
.vdn__container {
  background-color: #fff;
  overflow-x: hidden;
  padding-bottom: 30px;
}
.mmf__item {
  width: 100%;
  height: auto;
  overflow-x: hidden;
  padding-top: 40px;
}
.mmf__item:first-of-type {
  padding-top: 0px;
}
.mmf__item>img {
  width: 100%;
  display: block;
}
.mmf__item_padding{
  display: block;
  margin: 0 10px;
  background: #fafafa;
  height: 20px;
}
/* .mmf__table {
  width: 100%;
  padding-left: .2rem;
  box-sizing: border-box;
  display: block;
  overflow-x: auto;
}
.mmf__table img{
  width: auto;
  display: block;
  height: 4.4rem;
  padding-right: .2rem;
} */
</style>
